import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import { ReactSVG } from "react-svg";
import NftImg from '@/assets/imgs/nfts/5.jpg'
import { NFTCA, nftAbi } from '@/utils/abi'
import {  useContractReads, useAccount } from 'wagmi'

import NftImg1 from '@/assets/imgs/nfts/1.jpg'
import NftImg2 from '@/assets/imgs/nfts/2.jpg'
import NftImg3 from '@/assets/imgs/nfts/3.jpg'
import NftImg4 from '@/assets/imgs/nfts/4.jpg'
import NftImg5 from '@/assets/imgs/nfts/5.jpg'
import NftImg6 from '@/assets/imgs/nfts/6.jpg'
import { useNavigate, Outlet } from "react-router-dom";
import { useState } from "react";
export default function MintResult({ handleClose, minted }) {
  
  const navigate = useNavigate();

  const [seconds, setSeconds] = useState(3)
  // const [seconds, setSeconds] = useState(86400)
  
  
  const toMy = ()=>{
    navigate('/my');
  }
  const { address } = useAccount();  

  const nftContract = {
    address: NFTCA,
    abi: nftAbi
  }

  const config = (minted?.length || []) && {    
    contracts: minted.map(i => ({
      ...nftContract,
      functionName: 'tokenTypes',
      args: [i],
    })),
    onError(error) {
      console.log('Error', error)
    }
  }

  let { data:nftList } = useContractReads(config)
  console.log(nftList);
  
  return (
    <Modal>      
      <div className='close' onClick={handleClose}><ReactSVG src={CloseImg}/></div>
      <div className="content">        
        <div className="main-title">Mint {!(nftList && nftList.length) ? 'Failed' : 'Successful'}！</div>
        <div className="line"></div>
        <div className="inner">
          <div className="f-l">          
            {
              (nftList || []).map((i, idx) => <img key={idx} className="nft-img" src={
                i === 1 ? NftImg1 : (
                  i === 2 ? NftImg2 : (
                    i === 3 ? NftImg3 :(
                      i === 4 ? NftImg4 : (
                        i === 5 ? NftImg6 : NftImg5
                      )
                    )
                  )
                )
                
              } alt="" /> )
            }
          </div>
          <div className="btns-group">
            <div className="common-btn l" onClick={toMy}>Check My Squad</div>
            <div className="common-btn r" onClick={handleClose}>Mint More</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .inner{
    .f-l{
      margin-top: 39px;
      display: flex;
      justify-content: center;
      .nft-img{
        width: 300px;
        border-radius: 20px;
        & + .nft-img{
          margin-left: 30px;
        }
      }
    }
  }
  .btns-group{
    display: flex;
    justify-content: center;
    margin-top: 57px;
    .common-btn{
      width: 392px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;    
      border-radius: 8px;
      cursor: pointer;
    }
    .l{
      color: #32DE86;
      background: #FFFFFF;
    }
    .r{
      background: #32DE86;
      margin-left: 40px;
    }
  }
  .close {
    position: absolute;
    right: 44px;
    top: 40px;
    cursor: pointer;
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 40px;
    .main-title{
      width: 100%;
      font-weight: 600;
      text-align: left;
      font-size: 30px;
      line-height: 42px;
      padding-bottom: 20px;
      color: #32DE86;
    }
    .line{
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.15);
    }
    
  }

  

`;
